
export const enableCaptcha =
 (window.location.host === 'incrowdanswers.com')
 || (window.location.host === 'www.incrowdanswers.com')
//  || (window.location.host === 'web-qa.incrowdanswers.com')
//  || (window.location.host === 'www.web-qa.incrowdanswers.com')
//  || (window.location.host === 'opinionsite_web-qa.incrowdanswers.com')
//  || (window.location.host === 'www.opinionsite_web-qa.incrowdanswers.com')
 || (window.location.host === 'opinionsite.incrowdanswers.com')
 || (window.location.host === 'www.opinionsite.incrowdanswers.com')
 || (window.location.host === 'opinionsiteanswers.com')
//  || (window.location.host === 'web-qa.opinionsiteanswers.com')

export const generateNewCaptchaToken = (onGenerateComplete) => {
    if (enableCaptcha) {
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(undefined, { action: "login" })
                .then(token => {
                    onGenerateComplete(token)
                })
        })
    } else {
        onGenerateComplete("")
    }
}